<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-default-button fas fa-times-circle" @click="$emit('togglemodal')"></div>
                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'Modal'
    }
</script>


// WEBPACK FOOTER //
// src/components/Modal.vue